import { FuzeLogoLoader } from '@/components/Logo'
import { useTranslation } from 'react-i18next'
import { Heading, PageContainer, VStack } from './Atoms'

const loadingTextKeys = [
  'loading.crunchingNumbers',
  'loading.herdingDataPoints',
  'loading.untanglingSpreadsheets',
  'loading.brewingBusinessIntelligence',
  'loading.connectingTheDots',
  'loading.processingOnesAndZeros',
  'loading.makingDataBeautiful',
]

const LoadingContent = (props: { loadingText?: string; offset?: boolean }) => {
  const { t } = useTranslation('common')
  const randomLoadingTextKey = loadingTextKeys[Math.floor(Math.random() * loadingTextKeys.length)]

  return (
    <VStack gap="xl" align="center" className={props.offset ? '-mt-56' : ''}>
      <FuzeLogoLoader isLoading logoOnly className="size-24 opacity-20" />
      <Heading level={3} weight="weak" leading="none" className="opacity-30 dark:opacity-50">
        {props.loadingText ?? t(randomLoadingTextKey)}
      </Heading>
    </VStack>
  )
}

type PageLoaderProps = {
  global?: boolean
  loadingText?: string
  offset?: boolean
}

export function PageLoader(props: PageLoaderProps) {
  if (props.global) {
    return (
      <div className="flex h-[100svh] w-full flex-col items-center justify-center">
        <LoadingContent loadingText={props.loadingText} offset={props.offset || false} />
      </div>
    )
  }
  return (
    <PageContainer>
      <div className="flex h-[calc(100svh-173px)] items-center justify-center">
        <LoadingContent loadingText={props.loadingText} offset={props.offset || true} />
      </div>
    </PageContainer>
  )
}
